// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"oqV0LxSa6yJ+"};